import { useState } from 'react';
import { Button } from '../../../../../../../components/button/button';
import { Container } from '../../../../../../../components/container/container';
import { ModalProps, Modal } from '../../../../../../../components/modal/modal';
import { Select } from '../../../../../../../components/select/select';
import { LangInput } from '../../../../../../../features/lang-input/lang-input';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useBranchesStore } from '../../../../../../../store/use-branch-store';
import { useDishMenuStore } from '../../../../../../../store/use-dish-menu-store';
import s from './menu-informer-copy-menu-modal.module.css';
import { DishMenuType } from '../../../../../../../store/api/dish-menu-api';
import { useQueryParams } from '../../../../../../../hooks/use-query-params';

export const MenuInformerCopyMenuModal = (props: ModalProps) => {
  const { cloneMenu, isLoading } = useDishMenuStore();
  const { place = [] } = useBranchesStore();
  const { t, getLocale } = useLang();

  const params = useQueryParams().getQueryParams();
  const copyMenu = params?.copyMenu ? JSON.parse(params.copyMenu) as DishMenuType : null;

  const [menu, setMenu] = useState(copyMenu);
  const selectedBranch = place.find((item) => item.id === menu?.place_id);

  const handleCopy = async () => {
    try {
      menu && await cloneMenu(menu);
      props.onClose();
    } catch (e) {
      console.error(e);
    }
  };

  const handleUpdateMenu = (data: Partial<DishMenuType>) => {
    const prev = menu;
    if (!prev) return;
    const updatedMenu = {
      ...prev,
      ...data,
    };
    setMenu(updatedMenu);
  };

  return (
    <Modal {...props} className={s.feature} title={t('Копирование меню') + ' ' + getLocale(copyMenu?.name)}>
      <Container label={t('Название')}>
        <LangInput onChange={(e) => handleUpdateMenu({ name: e })} value={menu?.name} />
      </Container>
      <Container label={t('Филиал')}>
        <Select
          options={place?.map((item) => ({ id: String(item.id), value: getLocale(item.name) }))}
          value={
            selectedBranch
              ? { id: String(selectedBranch.id), value: getLocale(selectedBranch.name) }
              : undefined
          }
          onSelect={(e) => handleUpdateMenu({ place_id: Number(e.id) })}
        />
      </Container>

      <div className={s.controls}>
        <Button variant="secondary" onClick={props.onClose} disabled={isLoading}>
          {t('Отменить')}
        </Button>
        <Button onClick={handleCopy} disabled={isLoading}>
          {t('Копировать')}
        </Button>
      </div>
    </Modal>
  );
};
